/** localStorage draft for /smokerprofile — merged with other survey data on final submit. */
export const SMOKER_PROFILE_STORAGE_KEY = 'npdsurvey:smokerProfile';

export const NATIONALITY_MALAYSIAN = 'Malaysian';
export const NATIONALITY_NON_MALAYSIAN = 'Non-Malaysian';

export type SmokerNationality =
  | typeof NATIONALITY_MALAYSIAN
  | typeof NATIONALITY_NON_MALAYSIAN;

export type SmokerProfileAnswers = {
  name: string;
  email: string;
  nationality: string;
  country: string;
  race: string;
  state: string;
  /** Previous smoking brand (from ComCat catalog). */
  brand: string;
  variant: string;
};

function isSmokerNationality(v: unknown): v is SmokerNationality {
  return v === NATIONALITY_MALAYSIAN || v === NATIONALITY_NON_MALAYSIAN;
}

export function readSmokerProfileAnswers(): Partial<SmokerProfileAnswers> | null {
  try {
    const raw = localStorage.getItem(SMOKER_PROFILE_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const p = o as Record<string, unknown>;
    return {
      name: typeof p.name === 'string' ? p.name : '',
      email: typeof p.email === 'string' ? p.email : '',
      nationality: typeof p.nationality === 'string' ? p.nationality : '',
      country: typeof p.country === 'string' ? p.country : '',
      race: typeof p.race === 'string' ? p.race : '',
      state: typeof p.state === 'string' ? p.state : '',
      brand: typeof p.brand === 'string' ? p.brand : '',
      variant: typeof p.variant === 'string' ? p.variant : '',
    };
  } catch {
    return null;
  }
}

export function writeSmokerProfileAnswers(data: SmokerProfileAnswers): void {
  try {
    localStorage.setItem(SMOKER_PROFILE_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* quota / private mode */
  }
}

export function clearSmokerProfileAnswers(): void {
  try {
    localStorage.removeItem(SMOKER_PROFILE_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isSmokerProfileComplete(): boolean {
  const s = readSmokerProfileAnswers();
  if (!s) return false;
  const nationality = typeof s.nationality === 'string' ? s.nationality.trim() : '';
  if (!isSmokerNationality(nationality)) return false;

  const brandOk =
    typeof s.brand === 'string' &&
    s.brand.trim().length > 0 &&
    typeof s.variant === 'string' &&
    s.variant.trim().length > 0;
  if (!brandOk) return false;

  if (nationality === NATIONALITY_NON_MALAYSIAN) {
    return typeof s.country === 'string' && s.country.trim().length > 0;
  }

  return (
    typeof s.race === 'string' &&
    s.race.trim().length > 0 &&
    typeof s.state === 'string' &&
    s.state.trim().length > 0
  );
}
